// 活動頁內容
"use client";
import { useTranslation } from "react-i18next";
import EventComponent from "../basic/EventComponent";
import LoadMore from "../index/LoadMore";
import { useParams } from "next/navigation";
import { useEffect, useState } from "react";
import { getEvents } from "@/app/actions";
import EmptyResult from "../search/EmptyResult";

const EventsItems = ({ initialEvents, filter }) => {
  const { locale } = useParams(); // 取得語系
  const { t } = useTranslation();
  const { pageCnt, records } = initialEvents;
  const [events, setEvents] = useState(records); // 活動列表 資料
  const [pageIndex, setPageIndex] = useState(1); // 頁碼
  const [hasMoreData, setHasMoreData] = useState(true); // 是否還有資料

  //   加載更多
  const onLoad = async () => {
    if (!hasMoreData) return;
    const { records } = await getEvents(locale, pageIndex, filter);
    if (records) {
      setPageIndex((prev) => prev + 1);
      setEvents((prev) => prev.concat(records));
    }
  };

  // 判斷是否顯示 load more
  const handleHasMoreData = () => {
    if (pageIndex === pageCnt) setHasMoreData(false);
  };

  useEffect(() => {
    handleHasMoreData();
  }, [pageIndex]);

  useEffect(() => {
    setEvents(initialEvents?.records);
  }, [initialEvents]);

  return (
    <div
      className="pt-[22px] asm:border-t-1 border-black2  border-opacity-[.5]
            [&>section]:flex [&>section]:flex-wrap [&>section]:items-start space-y-[75px] w-full"
    >
      <section
        className="flex items-start gap-x-[30px] umd:gap-x-0 gap-y-[60px]
            [&>*]:w-[calc((100%-60px)/3)] bmd:[&>*]:w-[calc((100%-20px)/2)] usm:[&>*]:w-[calc((100%-30px)/1)] bmd:justify-between usm:justify-center"
      >
        {events?.length > 0 ? (
          events?.map((item, i) => (
            <EventComponent key={`event-${i}`} t={t} info={item} />
          ))
        ) : (
          <EmptyResult t={t}/>
        )}
      </section>

      {/* 更多 */}
      {hasMoreData && <LoadMore onLoad={onLoad} />}
    </div>
  );
};

export default EventsItems;
